<template>
  <AppCookieBanner />
  <AppHeader />
  <BaseMain>
    <client-only>
      <v-slide-x-transition>
        <div
          v-show="isNavigationOpened"
          class="px-4 pt-6 position-fixed bg-ui-kit-bg-gray-0 mobile-sidebar-navigation"
        >
          <div
            v-for="(section, index) in sections"
            :key="index"
            class="pa-3"
          >
            <NuxtLink
              class="section-link text-decoration-none pl-0 mb-1 text-body-1"
              active-class="text-primary"
              :to="section.to"
              @click="isNavigationOpened = false"
            >
              <span v-html="section.title" />
            </NuxtLink>
          </div>
          <div
            v-if="locale.isRu"
            class="pa-3"
          >
            <NuxtLink
              href="/documents/users-guide.pdf"
              class="section-link text-body-1 ui-kit-icon-text-primary text-decoration-none"
              external
              @click="isNavigationOpened = false"
            >
              Руководство пользователя
            </NuxtLink>
          </div>
        </div>
      </v-slide-x-transition>
      <v-tooltip
        z-index="0"
        scroll-strategy="block"
        content-class="d-none"
        :model-value="isNavigationOpened"
      />
    </client-only>

    <v-container class="pt-6 pb-8 pt-md-8 pb-md-0 px-4 px-md-2">
      <div class="d-flex">
        <v-sheet
          min-width="278"
          class="sections-list mr-8 d-none d-md-block"
        >
          <div
            v-for="(section, index) in sections"
            :key="index"
            class="mb-6 pt-1"
          >
            <NuxtLink
              class="section-link text-decoration-none pl-0 mb-1 text-body-1"
              active-class="text-primary"
              :to="section.to"
            >
              <span v-html="section.title" />
            </NuxtLink>
          </div>
          <NuxtLink
            v-if="locale.isRu"
            href="/documents/users-guide.pdf"

            class="section-link text-body-1 ui-kit-icon-text-primary text-decoration-none"
            external
          >
            Руководство пользователя
          </NuxtLink>
        </v-sheet>

        <div class="pb-md-16 content">
          <slot />
        </div>
      </div>
    </v-container>
  </BaseMain>
  <AppFooter />
</template>

<script setup lang="ts">
import { useDisplay, useLayout } from 'vuetify'

const isNavigationOpened = ref(false)

const { mdAndUp } = useDisplay()
const { mainRect } = useLayout()
const locale = useAppLocale()
const topCssValue = computed(() => toCssSize(mainRect.value.top))

const sections = computed(() => {
  return [
    {
      title: 'Пользовательское соглашение',
      to: withRouteParams({ name: 'terms-of-use' }),
    },
    {
      title: 'Политика обработки <br />персональных данных',
      to: withRouteParams({ name: 'privacy-policy' }),
    },
    {
      title: 'Лицензионное соглашение',
      to: withRouteParams({ name: 'license-agreement' }),
    },
    ...(locale.isRu
      ? [
        {
          title: 'Публичная оферта',
          to: withRouteParams({ name: 'public-offer' }),
        },
        {
          title: 'Документы юрлица',
          to: withRouteParams({ name: 'documents' }),
        },
      ]
      : []),
  ]
})

if (import.meta.client) {
  watch(mdAndUp, (value) => {
    if (isNavigationOpened.value && value) {
      isNavigationOpened.value = false
    }
  })
}
</script>

<style lang="scss" scoped>
@use '@/assets/vuetify/settings';
@use 'sass:map';

.sections-list {
  position: fixed;
}

.section-link {
  color: $t-ui-text;

  &:hover {
    color: $t-primary;
  }
}

.content {
  @media #{map.get(settings.$display-breakpoints, 'md-and-up')} {
    margin-left: 300px;
  }
}

.mobile-sidebar-navigation {
  z-index: 1;
  inset: v-bind(topCssValue) 0 0;
}
</style>
